<template>
	<div class="companies">
		<div
			v-for="company in companies"
			:key="company.id"
			style="cursor: pointer; display: flex; justify-content: stretch; flex-direction: column; align-self: flex-start;"
			@click="setCompany(company.id)"
		>
			<t-card
				:id="company.id"
				href="#"
				background="tint1"
				elevation="1"
				elevation-hover="2"
				elevation-active="0"
			>
				<div class="company">
					<img class="company-logo" :src="getLogoUrl(company.id)">
					<span class="company-name">{{company.displayName}}</span>
				</div>
			</t-card>
		</div>
	</div>
</template>

<script>
import { publicBaseUrl } from '@/core';
import {
	mapState, mapMutations, mapActions
} from './store/login.store.js';
export default {
	computed: { ...mapState(['companies']), },
	async created() {
		await this.fetchCompanies();
	},
	methods: {
		...mapMutations(['setTransporterCode']),
		...mapActions(['fetchCompanies',]),
		setCompany(transporterCode) {
			this.setTransporterCode(transporterCode);
		},
		getLogoUrl(companyId) {
			return `${publicBaseUrl()}/companies/logo/${companyId}`;
		}
	},
};
</script>

<style lang="scss" scoped>
.companies {
	display: grid;
	padding: 20px;
	grid-gap: 15px 15px;
	grid-auto-rows: 100px;
	grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
}
.company {
	height: 100%;
	padding: 10px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	&-logo {
		object-fit: contain;
		display: block;
		height: 40px;
	}

	&-name {
		display: block;

	}
}
</style>